import type { CollectiblesProps } from './collectibles.component';

/**
 * Maps HTML attribute names (kebab-case) to PromotedProductsComponent prop names (camelCase)
 */
export const COLLECTIBLES_ATTRIBUTE_MAP: Record<string, keyof CollectiblesProps> = {
  'internal-title': 'internalTitle',
  'title-size': 'titleSize',
  description: 'description',
  'show-collectible-title': 'showCollectibleTitle',
  'show-mint-number': 'showMintNumber',
  'collectible-title-size': 'collectibleTitleSize',
  'collectible-title-alignment': 'collectibleTitleAlignment',
  'show-login': 'showLogin',
  'logged-in': 'loggedIn',
  'max-width': 'maxWidth',
  'text-color': 'textColor',
  'section-background-color': 'sectionBackgroundColor',
  'button-background-color': 'buttonBackgroundColor',
  'button-text-color': 'buttonTextColor',
  'button-border-color': 'buttonBorderColor',
  'image-border-color': 'imageBorderColor',
  'hover-background-color': 'hoverBackgroundColor',
  columns: 'columns',
  'image-border-radius': 'imageBorderRadius',
  'image-border-width': 'imageBorderWidth',
  'button-border-radius': 'buttonBorderRadius',
  'button-border-width': 'buttonBorderWidth',
  'horizontal-padding': 'horizontalPadding',
  'vertical-padding': 'verticalPadding',
};

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set([
  'loggedIn',
  'maxWidth',
  'showCollectibleTitle',
  'showMintNumber',
  'showLogin',
]);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to CollectiblesComponent props
 */
export function extractCollectiblesAttributes(element: HTMLElement): Partial<CollectiblesProps> {
  const props: Partial<CollectiblesProps> = {};

  for (const [attrName, propName] of Object.entries(COLLECTIBLES_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }

  return props;
}
